module.exports = __webpack_public_path__ + "static/media/thumbnail-live.9fc821df.png";